/**
 * Wrapper for animation frames - takes one callback
 *  - The callback will be executed on every frame until calling stop()
 *
 * @class AnimationFrame
 */
class AnimationFrame {
  constructor(fn) {
    this.fn = fn;
    this._alive = true;
  }

  /**
   * `true` if alive; `false` otherwise
   *
   * @readonly
   */
  get alive() {
    return this._alive;
  }

  /**
   * Starts the execution of callback on each frame
   *
   * @returns {AnimationFrame}
   */
  start() {
    this.fn();

    if (this._alive) {
      window.requestAnimationFrame(this.start.bind(this));
    }

    return this;
  }

  /**
   * Stops the execution of callback
   *
   * @returns {AnimationFrame}
   */
  stop() {
    this._alive = false;
    return this;
  }
}

export default AnimationFrame;
